import { BadgeDollarSign } from "lucide-react";
import { formatWage, type CustomWage } from "../utils/custom-wage";

interface CustomWageNoticeProps {
  customWage: CustomWage;
}

/** Read-only line showing the provider-proposed wage on a shift. */
export function CustomWageNotice({ customWage }: CustomWageNoticeProps) {
  return (
    <div className="flex items-center gap-1.5 text-sm font-medium text-amber-800">
      <BadgeDollarSign className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>Custom wage: {formatWage(customWage)}</span>
    </div>
  );
}
